// fox
import { ReactComponent as FoxOk } from './fox/fox_ok.svg'
import { ReactComponent as FoxExcited } from './fox/fox_excited.svg'
import { ReactComponent as FoxSad } from './fox/fox_sad.svg'
import { ReactComponent as FoxHappy } from './fox/fox_happy.svg'
import { ReactComponent as FoxAfraid } from './fox/fox_afraid.svg'
import { ReactComponent as FoxAngry } from './fox/fox_angry.svg'
// panda
import { ReactComponent as PandaOk } from './panda/panda_ok.svg'
import { ReactComponent as PandaExcited } from './panda/panda_excited.svg'
import { ReactComponent as PandaSad } from './panda/panda_sad.svg'
import { ReactComponent as PandaHappy } from './panda/panda_happy.svg'
import { ReactComponent as PandaAfraid } from './panda/panda_afraid.svg'
import { ReactComponent as PandaAngry } from './panda/panda_angry.svg'
// tiger
import { ReactComponent as TigerOk } from './tiger/tiger_ok.svg'
import { ReactComponent as TigerExcited } from './tiger/tiger_excited.svg'
import { ReactComponent as TigerSad } from './tiger/tiger_sad.svg'
import { ReactComponent as TigerHappy } from './tiger/tiger_happy.svg'
import { ReactComponent as TigerAfraid } from './tiger/tiger_afraid.svg'
import { ReactComponent as TigerAngry } from './tiger/tiger_angry.svg'
// raccoon
import { ReactComponent as RaccoonOk } from './raccoon/raccoon_ok.svg'
import { ReactComponent as RaccoonExcited } from './raccoon/raccoon_excited.svg'
import { ReactComponent as RaccoonSad } from './raccoon/raccoon_sad.svg'
import { ReactComponent as RaccoonHappy } from './raccoon/raccoon_happy.svg'
import { ReactComponent as RaccoonAfraid } from './raccoon/raccoon_afraid.svg'
import { ReactComponent as RaccoonAngry } from './raccoon/raccoon_angry.svg'
// shark
import { ReactComponent as SharkOk } from './shark/shark_ok.svg'
import { ReactComponent as SharkExcited } from './shark/shark_excited.svg'
import { ReactComponent as SharkSad } from './shark/shark_sad.svg'
import { ReactComponent as SharkHappy } from './shark/shark_happy.svg'
import { ReactComponent as SharkAfraid } from './shark/shark_afraid.svg'
import { ReactComponent as SharkAngry } from './shark/shark_angry.svg'
// hamster
import { ReactComponent as HamsterOk } from './hamster/hamster_ok.svg'
import { ReactComponent as HamsterExcited } from './hamster/hamster_excited.svg'
import { ReactComponent as HamsterSad } from './hamster/hamster_sad.svg'
import { ReactComponent as HamsterHappy } from './hamster/hamster_happy.svg'
import { ReactComponent as HamsterAfraid } from './hamster/hamster_afraid.svg'
import { ReactComponent as HamsterAngry } from './hamster/hamster_angry.svg'
// penguin
import { ReactComponent as PenguinOk } from './penguin/penguin_ok.svg'
import { ReactComponent as PenguinExcited } from './penguin/penguin_excited.svg'
import { ReactComponent as PenguinSad } from './penguin/penguin_sad.svg'
import { ReactComponent as PenguinHappy } from './penguin/penguin_happy.svg'
import { ReactComponent as PenguinAfraid } from './penguin/penguin_afraid.svg'
import { ReactComponent as PenguinAngry } from './penguin/penguin_angry.svg'
// bear
import { ReactComponent as BearOk } from './bear/bear_ok.svg'
import { ReactComponent as BearExcited } from './bear/bear_excited.svg'
import { ReactComponent as BearSad } from './bear/bear_sad.svg'
import { ReactComponent as BearHappy } from './bear/bear_happy.svg'
import { ReactComponent as BearAfraid } from './bear/bear_afraid.svg'
import { ReactComponent as BearAngry } from './bear/bear_angry.svg'
// octopus
// import OctopusOk } from './octopus/octopus_ok.svg';
// import OctopusExcited } from './octopus/octopus_excited.svg';
// import OctopusSad } from './octopus/octopus_sad.svg';
// import OctopusHappy } from './octopus/octopus_happy.svg';
// import OctopusAfraid } from './octopus/octopus_afraid.svg';
// import OctopusAngry } from './octopus/octopus_angry.svg';
// dog
import { ReactComponent as DogOk } from './dog/dog_ok.svg'
import { ReactComponent as DogExcited } from './dog/dog_excited.svg'
import { ReactComponent as DogSad } from './dog/dog_sad.svg'
import { ReactComponent as DogHappy } from './dog/dog_happy.svg'
import { ReactComponent as DogAfraid } from './dog/dog_afraid.svg'
import { ReactComponent as DogAngry } from './dog/dog_angry.svg'
// bird
import { ReactComponent as BirdOk } from './bird/bird_ok.svg'
import { ReactComponent as BirdExcited } from './bird/bird_excited.svg'
import { ReactComponent as BirdSad } from './bird/bird_sad.svg'
import { ReactComponent as BirdHappy } from './bird/bird_happy.svg'
import { ReactComponent as BirdAfraid } from './bird/bird_afraid.svg'
import { ReactComponent as BirdAngry } from './bird/bird_angry.svg'
// koala
import { ReactComponent as KoalaOk } from './koala/koala_ok.svg'
import { ReactComponent as KoalaExcited } from './koala/koala_excited.svg'
import { ReactComponent as KoalaSad } from './koala/koala_sad.svg'
import { ReactComponent as KoalaHappy } from './koala/koala_happy.svg'
import { ReactComponent as KoalaAfraid } from './koala/koala_afraid.svg'
import { ReactComponent as KoalaAngry } from './koala/koala_angry.svg'
// giraffe
import { ReactComponent as GiraffeOk } from './giraffe/giraffe_ok.svg'
import { ReactComponent as GiraffeExcited } from './giraffe/giraffe_excited.svg'
import { ReactComponent as GiraffeSad } from './giraffe/giraffe_sad.svg'
import { ReactComponent as GiraffeHappy } from './giraffe/giraffe_happy.svg'
import { ReactComponent as GiraffeAfraid } from './giraffe/giraffe_afraid.svg'
import { ReactComponent as GiraffeAngry } from './giraffe/giraffe_angry.svg'
// otter
import { ReactComponent as OtterOk } from './otter/otter_ok.svg'
import { ReactComponent as OtterExcited } from './otter/otter_excited.svg'
import { ReactComponent as OtterSad } from './otter/otter_sad.svg'
import { ReactComponent as OtterHappy } from './otter/otter_happy.svg'
import { ReactComponent as OtterAfraid } from './otter/otter_afraid.svg'
import { ReactComponent as OtterAngry } from './otter/otter_angry.svg'
// deer
import { ReactComponent as DeerOk } from './deer/deer_ok.svg'
import { ReactComponent as DeerExcited } from './deer/deer_excited.svg'
import { ReactComponent as DeerSad } from './deer/deer_sad.svg'
import { ReactComponent as DeerHappy } from './deer/deer_happy.svg'
import { ReactComponent as DeerAfraid } from './deer/deer_afraid.svg'
import { ReactComponent as DeerAngry } from './deer/deer_angry.svg'
// bunny
import { ReactComponent as BunnyOk } from './bunny/bunny_ok.svg'
import { ReactComponent as BunnyExcited } from './bunny/bunny_excited.svg'
import { ReactComponent as BunnySad } from './bunny/bunny_sad.svg'
import { ReactComponent as BunnyHappy } from './bunny/bunny_happy.svg'
import { ReactComponent as BunnyAfraid } from './bunny/bunny_afraid.svg'
import { ReactComponent as BunnyAngry } from './bunny/bunny_angry.svg'
// elephant
import { ReactComponent as ElephantOk } from './elephant/elephant_ok.svg'
import { ReactComponent as ElephantExcited } from './elephant/elephant_excited.svg'
import { ReactComponent as ElephantSad } from './elephant/elephant_sad.svg'
import { ReactComponent as ElephantHappy } from './elephant/elephant_happy.svg'
import { ReactComponent as ElephantAfraid } from './elephant/elephant_afraid.svg'
import { ReactComponent as ElephantAngry } from './elephant/elephant_angry.svg'
// zebra
import { ReactComponent as ZebraOk } from './zebra/zebra_ok.svg'
import { ReactComponent as ZebraExcited } from './zebra/zebra_excited.svg'
import { ReactComponent as ZebraSad } from './zebra/zebra_sad.svg'
import { ReactComponent as ZebraHappy } from './zebra/zebra_happy.svg'
import { ReactComponent as ZebraAfraid } from './zebra/zebra_afraid.svg'
import { ReactComponent as ZebraAngry } from './zebra/zebra_angry.svg'
// sugarGlider
import { ReactComponent as SugarGliderOk } from './sugarGlider/sugarGlider_ok.svg'
import { ReactComponent as SugarGliderExcited } from './sugarGlider/sugarGlider_excited.svg'
import { ReactComponent as SugarGliderSad } from './sugarGlider/sugarGlider_sad.svg'
import { ReactComponent as SugarGliderHappy } from './sugarGlider/sugarGlider_happy.svg'
import { ReactComponent as SugarGliderAfraid } from './sugarGlider/sugarGlider_afraid.svg'
import { ReactComponent as SugarGliderAngry } from './sugarGlider/sugarGlider_angry.svg'
// leopard
import { ReactComponent as LeopardOk } from './leopard/leopard_ok.svg'
import { ReactComponent as LeopardExcited } from './leopard/leopard_excited.svg'
import { ReactComponent as LeopardSad } from './leopard/leopard_sad.svg'
import { ReactComponent as LeopardHappy } from './leopard/leopard_happy.svg'
import { ReactComponent as LeopardAfraid } from './leopard/leopard_afraid.svg'
import { ReactComponent as LeopardAngry } from './leopard/leopard_angry.svg'
// fish
import { ReactComponent as FishOk } from './fish/fish_ok.svg'
import { ReactComponent as FishExcited } from './fish/fish_excited.svg'
import { ReactComponent as FishSad } from './fish/fish_sad.svg'
import { ReactComponent as FishHappy } from './fish/fish_happy.svg'
import { ReactComponent as FishAfraid } from './fish/fish_afraid.svg'
import { ReactComponent as FishAngry } from './fish/fish_angry.svg'
// darkBear
import { ReactComponent as DarkBearOk } from './darkBear/darkBear_ok.svg'
import { ReactComponent as DarkBearExcited } from './darkBear/darkBear_excited.svg'
import { ReactComponent as DarkBearSad } from './darkBear/darkBear_sad.svg'
import { ReactComponent as DarkBearHappy } from './darkBear/darkBear_happy.svg'
import { ReactComponent as DarkBearAfraid } from './darkBear/darkBear_afraid.svg'
import { ReactComponent as DarkBearAngry } from './darkBear/darkBear_angry.svg'
// kitty
import { ReactComponent as KittyOk } from './kitty/kitty_ok.svg'
import { ReactComponent as KittyExcited } from './kitty/kitty_excited.svg'
import { ReactComponent as KittySad } from './kitty/kitty_sad.svg'
import { ReactComponent as KittyHappy } from './kitty/kitty_happy.svg'
import { ReactComponent as KittyAfraid } from './kitty/kitty_afraid.svg'
import { ReactComponent as KittyAngry } from './kitty/kitty_angry.svg'
// beaver
import { ReactComponent as BeaverOk } from './beaver/beaver_ok.svg'
import { ReactComponent as BeaverExcited } from './beaver/beaver_excited.svg'
import { ReactComponent as BeaverSad } from './beaver/beaver_sad.svg'
import { ReactComponent as BeaverHappy } from './beaver/beaver_happy.svg'
import { ReactComponent as BeaverAfraid } from './beaver/beaver_afraid.svg'
import { ReactComponent as BeaverAngry } from './beaver/beaver_angry.svg'
// frog
import { ReactComponent as FrogOk } from './frog/frog_ok.svg'
import { ReactComponent as FrogExcited } from './frog/frog_excited.svg'
import { ReactComponent as FrogSad } from './frog/frog_sad.svg'
import { ReactComponent as FrogHappy } from './frog/frog_happy.svg'
import { ReactComponent as FrogAfraid } from './frog/frog_afraid.svg'
import { ReactComponent as FrogAngry } from './frog/frog_angry.svg'
// hedgeHog
import { ReactComponent as HedgeHogOk } from './hedgeHog/hedgeHog_ok.svg'
import { ReactComponent as HedgeHogExcited } from './hedgeHog/hedgeHog_excited.svg'
import { ReactComponent as HedgeHogSad } from './hedgeHog/hedgeHog_sad.svg'
import { ReactComponent as HedgeHogHappy } from './hedgeHog/hedgeHog_happy.svg'
import { ReactComponent as HedgeHogAfraid } from './hedgeHog/hedgeHog_afraid.svg'
import { ReactComponent as HedgeHogAngry } from './hedgeHog/hedgeHog_angry.svg'
// lion
import { ReactComponent as LionOk } from './lion/lion_ok.svg'
import { ReactComponent as LionExcited } from './lion/lion_excited.svg'
import { ReactComponent as LionSad } from './lion/lion_sad.svg'
import { ReactComponent as LionHappy } from './lion/lion_happy.svg'
import { ReactComponent as LionAfraid } from './lion/lion_afraid.svg'
import { ReactComponent as LionAngry } from './lion/lion_angry.svg'
// lama
import { ReactComponent as LamaOk } from './lama/lama_ok.svg'
import { ReactComponent as LamaExcited } from './lama/lama_excited.svg'
import { ReactComponent as LamaSad } from './lama/lama_sad.svg'
import { ReactComponent as LamaHappy } from './lama/lama_happy.svg'
import { ReactComponent as LamaAfraid } from './lama/lama_afraid.svg'
import { ReactComponent as LamaAngry } from './lama/lama_angry.svg'
// owl
import { ReactComponent as OwlOk } from './owl/owl_ok.svg'
import { ReactComponent as OwlExcited } from './owl/owl_excited.svg'
import { ReactComponent as OwlSad } from './owl/owl_sad.svg'
import { ReactComponent as OwlHappy } from './owl/owl_happy.svg'
import { ReactComponent as OwlAfraid } from './owl/owl_afraid.svg'
import { ReactComponent as OwlAngry } from './owl/owl_angry.svg'
// rabbit
import { ReactComponent as RabbitOk } from './rabbit/rabbit_ok.svg'
import { ReactComponent as RabbitExcited } from './rabbit/rabbit_excited.svg'
import { ReactComponent as RabbitSad } from './rabbit/rabbit_sad.svg'
import { ReactComponent as RabbitHappy } from './rabbit/rabbit_happy.svg'
import { ReactComponent as RabbitAfraid } from './rabbit/rabbit_afraid.svg'
import { ReactComponent as RabbitAngry } from './rabbit/rabbit_angry.svg'

export const BigAnimalImages = {
    fox: {
        ok: <FoxOk width={218} />,
        excited: <FoxExcited width={218} />,
        sad: <FoxSad width={218} />,
        happy: <FoxHappy width={218} />,
        afraid: <FoxAfraid width={218} />,
        angry: <FoxAngry width={218} />,
    },
    panda: {
        ok: <PandaOk width={218} />,
        excited: <PandaExcited width={218} />,
        sad: <PandaSad width={218} />,
        happy: <PandaHappy width={218} />,
        afraid: <PandaAfraid width={218} />,
        angry: <PandaAngry width={218} />,
    },
    tiger: {
        ok: <TigerOk width={218} />,
        excited: <TigerExcited width={218} />,
        sad: <TigerSad width={218} />,
        happy: <TigerHappy width={218} />,
        afraid: <TigerAfraid width={218} />,
        angry: <TigerAngry width={218} />,
    },
    raccoon: {
        ok: <RaccoonOk width={218} />,
        excited: <RaccoonExcited width={218} />,
        sad: <RaccoonSad width={218} />,
        happy: <RaccoonHappy width={218} />,
        afraid: <RaccoonAfraid width={218} />,
        angry: <RaccoonAngry width={218} />,
    },
    shark: {
        ok: <SharkOk width={218} />,
        excited: <SharkExcited width={218} />,
        sad: <SharkSad width={218} />,
        happy: <SharkHappy width={218} />,
        afraid: <SharkAfraid width={218} />,
        angry: <SharkAngry width={218} />,
    },
    hamster: {
        ok: <HamsterOk width={218} />,
        excited: <HamsterExcited width={218} />,
        sad: <HamsterSad width={218} />,
        happy: <HamsterHappy width={218} />,
        afraid: <HamsterAfraid width={218} />,
        angry: <HamsterAngry width={218} />,
    },
    penguin: {
        ok: <PenguinOk width={218} />,
        excited: <PenguinExcited width={218} />,
        sad: <PenguinSad width={218} />,
        happy: <PenguinHappy width={218} />,
        afraid: <PenguinAfraid width={218} />,
        angry: <PenguinAngry width={218} />,
    },
    bear: {
        ok: <BearOk width={218} />,
        excited: <BearExcited width={218} />,
        sad: <BearSad width={218} />,
        happy: <BearHappy width={218} />,
        afraid: <BearAfraid width={218} />,
        angry: <BearAngry width={218} />,
    },
    octopus: {
        // ok: <OctopusOk width={218} />,
        // excited: <OctopusExcited width={218} />,
        // sad: <OctopusSad width={218} />,
        // happy: <OctopusHappy width={218} />,
        // afraid: <OctopusAfraid width={218} />,
        // angry: <OctopusAngry width={218} />,
    },
    dog: {
        ok: <DogOk width={218} />,
        excited: <DogExcited width={218} />,
        sad: <DogSad width={218} />,
        happy: <DogHappy width={218} />,
        afraid: <DogAfraid width={218} />,
        angry: <DogAngry width={218} />,
    },
    bird: {
        ok: <BirdOk width={218} />,
        excited: <BirdExcited width={218} />,
        sad: <BirdSad width={218} />,
        happy: <BirdHappy width={218} />,
        afraid: <BirdAfraid width={218} />,
        angry: <BirdAngry width={218} />,
    },
    koala: {
        ok: <KoalaOk width={218} />,
        excited: <KoalaExcited width={218} />,
        sad: <KoalaSad width={218} />,
        happy: <KoalaHappy width={218} />,
        afraid: <KoalaAfraid width={218} />,
        angry: <KoalaAngry width={218} />,
    },
    giraffe: {
        ok: <GiraffeOk width={218} />,
        excited: <GiraffeExcited width={218} />,
        sad: <GiraffeSad width={218} />,
        happy: <GiraffeHappy width={218} />,
        afraid: <GiraffeAfraid width={218} />,
        angry: <GiraffeAngry width={218} />,
    },
    otter: {
        ok: <OtterOk width={218} />,
        excited: <OtterExcited width={218} />,
        sad: <OtterSad width={218} />,
        happy: <OtterHappy width={218} />,
        afraid: <OtterAfraid width={218} />,
        angry: <OtterAngry width={218} />,
    },
    deer: {
        ok: <DeerOk width={218} />,
        excited: <DeerExcited width={218} />,
        sad: <DeerSad width={218} />,
        happy: <DeerHappy width={218} />,
        afraid: <DeerAfraid width={218} />,
        angry: <DeerAngry width={218} />,
    },
    bunny: {
        ok: <BunnyOk width={218} />,
        excited: <BunnyExcited width={218} />,
        sad: <BunnySad width={218} />,
        happy: <BunnyHappy width={218} />,
        afraid: <BunnyAfraid width={218} />,
        angry: <BunnyAngry width={218} />,
    },
    elephant: {
        ok: <ElephantOk width={218} />,
        excited: <ElephantExcited width={218} />,
        sad: <ElephantSad width={218} />,
        happy: <ElephantHappy width={218} />,
        afraid: <ElephantAfraid width={218} />,
        angry: <ElephantAngry width={218} />,
    },
    zebra: {
        ok: <ZebraOk width={218} />,
        excited: <ZebraExcited width={218} />,
        sad: <ZebraSad width={218} />,
        happy: <ZebraHappy width={218} />,
        afraid: <ZebraAfraid width={218} />,
        angry: <ZebraAngry width={218} />,
    },
    sugarGlider: {
        ok: <SugarGliderOk width={218} />,
        excited: <SugarGliderExcited width={218} />,
        sad: <SugarGliderSad width={218} />,
        happy: <SugarGliderHappy width={218} />,
        afraid: <SugarGliderAfraid width={218} />,
        angry: <SugarGliderAngry width={218} />,
    },
    leopard: {
        ok: <LeopardOk width={218} />,
        excited: <LeopardExcited width={218} />,
        sad: <LeopardSad width={218} />,
        happy: <LeopardHappy width={218} />,
        afraid: <LeopardAfraid width={218} />,
        angry: <LeopardAngry width={218} />,
    },
    fish: {
        ok: <FishOk width={218} />,
        excited: <FishExcited width={218} />,
        sad: <FishSad width={218} />,
        happy: <FishHappy width={218} />,
        afraid: <FishAfraid width={218} />,
        angry: <FishAngry width={218} />,
    },
    darkBear: {
        ok: <DarkBearOk width={218} />,
        excited: <DarkBearExcited width={218} />,
        sad: <DarkBearSad width={218} />,
        happy: <DarkBearHappy width={218} />,
        afraid: <DarkBearAfraid width={218} />,
        angry: <DarkBearAngry width={218} />,
    },
    kitty: {
        ok: <KittyOk width={218} />,
        excited: <KittyExcited width={218} />,
        sad: <KittySad width={218} />,
        happy: <KittyHappy width={218} />,
        afraid: <KittyAfraid width={218} />,
        angry: <KittyAngry width={218} />,
    },
    beaver: {
        ok: <BeaverOk width={218} />,
        excited: <BeaverExcited width={218} />,
        sad: <BeaverSad width={218} />,
        happy: <BeaverHappy width={218} />,
        afraid: <BeaverAfraid width={218} />,
        angry: <BeaverAngry width={218} />,
    },
    frog: {
        ok: <FrogOk width={218} />,
        excited: <FrogExcited width={218} />,
        sad: <FrogSad width={218} />,
        happy: <FrogHappy width={218} />,
        afraid: <FrogAfraid width={218} />,
        angry: <FrogAngry width={218} />,
    },
    hedgeHog: {
        ok: <HedgeHogOk width={218} />,
        excited: <HedgeHogExcited width={218} />,
        sad: <HedgeHogSad width={218} />,
        happy: <HedgeHogHappy width={218} />,
        afraid: <HedgeHogAfraid width={218} />,
        angry: <HedgeHogAngry width={218} />,
    },
    lion: {
        ok: <LionOk width={218} />,
        excited: <LionExcited width={218} />,
        sad: <LionSad width={218} />,
        happy: <LionHappy width={218} />,
        afraid: <LionAfraid width={218} />,
        angry: <LionAngry width={218} />,
    },
    lama: {
        ok: <LamaOk width={218} />,
        excited: <LamaExcited width={218} />,
        sad: <LamaSad width={218} />,
        happy: <LamaHappy width={218} />,
        afraid: <LamaAfraid width={218} />,
        angry: <LamaAngry width={218} />,
    },
    owl: {
        ok: <OwlOk width={218} />,
        excited: <OwlExcited width={218} />,
        sad: <OwlSad width={218} />,
        happy: <OwlHappy width={218} />,
        afraid: <OwlAfraid width={218} />,
        angry: <OwlAngry width={218} />,
    },
    rabbit: {
        ok: <RabbitOk width={218} />,
        excited: <RabbitExcited width={218} />,
        sad: <RabbitSad width={218} />,
        happy: <RabbitHappy width={218} />,
        afraid: <RabbitAfraid width={218} />,
        angry: <RabbitAngry width={218} />,
    },
}
